import type { FocusEvent, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import * as routingSelectors from '@makemydeal/dr-dash-store/selectors/router';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useRoleAssumptionSelector } from '@makemydeal/dr-shared-ui-utils';

import BackToMyDealButton from './BackButton.interstate';
import { BackButtonRow, HeaderRowContainer } from './Header.style.interstate';
import { CompactUIHeaderActions } from '../compactUIHeader/CompactUIHeaderActions';
import { HeaderRowInterstate } from './HeaderRow.interstate';
import { FixedHeaderContent } from './FixedHeaderContent.style';
import { MvHeaderLayout, MvHeaderRowContainer, MvHeaderScroller } from './MvHeaderLayout.style';

const scrollFocusedIntoView = (event: FocusEvent<HTMLDivElement>) => {
    event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
};

export const ContentHeader = ({ assistantEntry }: { assistantEntry?: ReactNode }) => {
    const theme = useInterstateTheme();
    const dashboardIsCurrentRoute = useSelector(routingSelectors.isDashboardCurrentRoute);
    const isMvRedesignEnabled = useSelector(featureToggleSelectors.isMvRedesignEnabled);

    const showBackButton = !dashboardIsCurrentRoute;

    const { isRoleAssumptionStarted } = useRoleAssumptionSelector();

    const headerRows = (
        <>
            <HeaderRowInterstate assistantEntry={assistantEntry} />
            <CompactUIHeaderActions />
        </>
    );

    return (
        <FixedHeaderContent theme={theme} isRoleAssumptionStarted={isRoleAssumptionStarted}>
            {showBackButton && (
                <BackButtonRow>
                    <BackToMyDealButton />
                </BackButtonRow>
            )}
            {isMvRedesignEnabled ? (
                <MvHeaderRowContainer className="compact-ui-header" theme={theme}>
                    <MvHeaderScroller data-testid="mv-header-scroller" onFocus={scrollFocusedIntoView}>
                        <MvHeaderLayout>{headerRows}</MvHeaderLayout>
                    </MvHeaderScroller>
                </MvHeaderRowContainer>
            ) : (
                <HeaderRowContainer className="compact-ui-header" theme={theme}>
                    {headerRows}
                </HeaderRowContainer>
            )}
        </FixedHeaderContent>
    );
};

export default ContentHeader;
